import React from 'react';
import PropTypes from 'prop-types';

const InputImages = (props) => (
    <div className={props.classContainer}>
        <div className={props.classImageLeft}>{props.imageLeft}</div>
        {props.children}
        {props.imageRight && <div className={props.classImageRight}>{props.imageRight}</div>}
    </div>
);

InputImages.propTypes = {
    imageLeft: PropTypes.object,
    imageRight: PropTypes.object,
    children: PropTypes.object,
    classContainer: PropTypes.string,
    classImageLeft: PropTypes.string,
    classImageRight: PropTypes.string
};

export default InputImages;
